// @ts-nocheck
import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function RouteScrollReset() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
    const reset = () => {
      document.scrollingElement?.scrollTo?.({ top: 0, left: 0, behavior: 'instant' });
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    };
    reset();
    const frame = window.requestAnimationFrame(reset);
    return () => window.cancelAnimationFrame(frame);
  }, [pathname]);

  return null;
}
